import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../store';

import CaseList from '../components/case/case-list';
import { Dispatch } from 'redux';
import Footer from '../components/common/footer';
import Header from '../components/common/header';
import MobileSearch from 'src/components/common/mobileSearch';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { setMobileView } from '../store/shared/actions';
import withParams from '../components/common/withParams';
import { Params } from 'react-router-dom';

interface PropsFromDispatch {
  readonly setMobileView: typeof setMobileView;
}
interface PropsFromState {
  isMobileViewSelected: boolean;
}

interface WithParamsProps {
  params: Params<string>;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps & WithParamsProps;

class Home extends React.Component<AllProps> {
  componentDidMount() {
    this.props.setMobileView(isMobile);
  }

  public render() {
    const HeaderWithParams = withParams(Header);

    if (this.props.isMobileViewSelected) {
      return (
        <MobileSearch {...this.props} />
        );
    } else {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden'
        }}>
          <HeaderWithParams {...this.props} />
          <CaseList {...this.props} />
          <Footer {...this.props} />
        </div>);
    }
  }
}

const mapStateToProps = ({ shared }: ApplicationState): PropsFromState => ({
  isMobileViewSelected: shared.isMobileViewSelected
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setMobileView: (mobileViewSelected: boolean) => dispatch(setMobileView(mobileViewSelected))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
